import styled from "styled-components";

export const SwitchWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 96px;

  .ant-switch-inner {
    min-width: 64px;
  }

  button {
    height: 34px;
  }

  .ant-switch-handle {
    top: 3px;
    width: 28px;
    height: 28px;
    margin-left: 1px;
  }

  .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 18px - 14px);
  }

  .ant-switch-handle::before {
    border-radius: 50%;
  }
`;
